import { DocsAnalyticsComparisonData } from "./SDKDocsAnalyticsComparisonData";
export class DocsAnalyticsPageComparisonData extends DocsAnalyticsComparisonData {
    constructor(model) {
        super(model);
        this.pagePersistentId = model.pagePersistentId;
    }
}
